import { useEffect, useState } from "react";
import { PortalLayout } from "@/components/layout/PortalLayout";
import { GlassCard } from "@/components/GlassCard";
import api from "@/lib/api";
import { goldBtnSm } from "@/lib/constants";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data.items || []));
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <PortalLayout title="Notifications">
      <div className="flex justify-end mb-4">
        <button onClick={markAll} className={goldBtnSm} data-testid="notif-mark-all">Mark all read</button>
      </div>
      <div className="space-y-3" data-testid="notification-list">
        {items.length === 0 && <GlassCard className="p-10 text-center text-sm text-muted-foreground">No notifications.</GlassCard>}
        {items.map((n) => (
          <GlassCard key={n.id} data-testid="notification-item" onClick={() => markOne(n.id)}
            className={`p-5 flex items-start justify-between gap-4 cursor-pointer ${!n.read ? "border-[hsl(var(--pdg-gold)/0.3)]" : ""}`}>
            <div>
              <div className="flex items-center gap-2">
                {!n.read && <span className="w-2 h-2 rounded-full bg-[hsl(var(--pdg-gold))]" />}
                <h3 className="text-sm text-foreground font-medium">{n.title}</h3>
              </div>
              {n.body && <p className="mt-1 text-sm text-muted-foreground">{n.body}</p>}
            </div>
            <span className="text-xs text-muted-foreground whitespace-nowrap">{new Date(n.created_at).toLocaleString()}</span>
          </GlassCard>
        ))}
      </div>
    </PortalLayout>
  );
}
